module.exports = __webpack_public_path__ + "img/dashboard-down.d2a0eac2.svg";